<template>
	<div class="h-screen pt-6 flex flex-col bg-white">
		<Container class="w-full">
			<PageHeading :title="$t('pages.admin.users.users_admin_layout.admin_users')"/>
		</Container>

		<TabLayout :tabs="tabs"/>

		<div class="flex-1 flex flex-col overflow-hidden">
			<router-view class="flex-1"></router-view>
		</div>

	</div>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";

export default {
	name: "UsersAdminLayout",
	components: {Container, PageHeading, TabLayout},
	data() {
		return {}
	},
	computed: {
		tabs() {
			return [
				{
					label: this.$t('pages.admin.users.users_admin_layout.users'),
					current: this.$route.name === 'admin.users' || this.$route.name.startsWith('admin.users.user'),
					to: {name: 'admin.users'},
					permission: 'create:users|update:users',
				},
				{
					label: this.$t('pages.admin.users.users_admin_layout.roles'),
					current: this.$route.name === 'admin.users.roles' || this.$route.name.startsWith('admin.users.roles.role'),
					to: {name: 'admin.users.roles'},
					permission: 'create:roles|update:roles',
				},
				{
					label: this.$t('pages.admin.users.users_admin_layout.permissions'),
					current: this.$route.name === 'admin.users.permissions' || this.$route.name.startsWith('admin.users.permissions.permission'),
					to: {name: 'admin.users.permissions'},
					permission: 'create:permissions|update:permissions',
				},
				{
					label: this.$t('pages.admin.users.users_admin_layout.teams'),
					current: this.$route.name === 'admin.users.teams' || this.$route.name.startsWith('admin.users.teams.team'),
					to: {name: 'admin.users.teams'},
					permission: 'create:teams|update:teams',
				},
			].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission))
		},
	},
}
</script>

<style scoped>

</style>